import { Alert, TextButton } from '@zillow/constellation-10';
import { ZILLOW_LEASES_EMAIL } from '../../constants/stringConstants';

export default function NoAccessLeaseRenewalAlert() {
  return (
    <Alert
      tone="critical"
      actionButton={
        <TextButton asChild tone="brand">
          <a href={`mailto:${ZILLOW_LEASES_EMAIL}`}>Get lease help</a>
        </TextButton>
      }
    >
      You either don’t have access to this lease renewal agreement or this link has expired. Check the link and try
      again.
    </Alert>
  );
}
